import * as React from "react";
import { useCommonHooks, useEditRouteParams } from "../../../hooks";
import { useQuery } from "react-query";
import { ERoutes } from "../../../AppRouter";
import { Spinner, SpinnerSize, Tab, Tabs } from "@blueprintjs/core";
import { BackButton, PageBase } from "../../../components";
import FunctionalDirectorDetailPanel from "./FunctionalDirectorDetailPanel";

export interface IFunctionalDirectorItemPageProps {}

export const FunctionalDirectorItemPage: React.FunctionComponent<
  IFunctionalDirectorItemPageProps
> = () => {
  const { t, router, apis } = useCommonHooks();
  const { id, tab } = useEditRouteParams();

  const { data: displayName, isFetching: loadingDisplayName } = useQuery(
    ["functional-director-display-name", id],
    async () => {
      if (+id > 0) {
        return await apis.functionalDirectors.getDisplayName(+id);
      }
      return t("NewFunction");
    }
  );

  const breadCrumbs = React.useMemo(() => {
    return [
      { text: t("FunctionalDirectorList"), route: ERoutes.functionalDirectors },
      {
        text: loadingDisplayName ? (
          <Spinner size={SpinnerSize.SMALL} />
        ) : (
          displayName.text
        ),
      },
    ];
  }, [displayName, loadingDisplayName, t]);

  return (
    <PageBase breadCrumbs={breadCrumbs}>
      <Tabs
        selectedTabId={tab}
        onChange={(nextTabId) =>
          router.push(`${ERoutes.functionalDirectors}/${id}/${nextTabId}`)
        }
      >
        <BackButton backRoute={ERoutes.functionalDirectors} />
        <Tab
          id="details"
          title={t("Details")}
          panel={<FunctionalDirectorDetailPanel id={+id} />}
        />
      </Tabs>
    </PageBase>
  );
};

export default FunctionalDirectorItemPage;
